export default "https://cdn-static.gokick.com/assets/89c12df47656b56f32e50d5631dab02a560652ab/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";